@if (ergebnis; as e) {
  <div class="ki-ergebnis" role="status" aria-live="polite">
    <div class="ki-ergebnis__kopf">
      <mat-icon class="ki-ergebnis__haken">check_circle</mat-icon>
      <span class="ki-ergebnis__titel">
        {{ e.texte.length === 1 ? 'KI-Antwort' : e.texte.length + ' KI-Antworten' }}
        eingetroffen@if (e.name) { <span class="ki-ergebnis__zeile">– {{ e.name }}</span> }
      </span>
      <button type="button" class="ki-ergebnis__schliessen"
        title="Meldung ausblenden" aria-label="Meldung ausblenden"
        (click)="schliessen()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Ein Block je erzeugtem Text. Im Reiter "Heute" sind es zwei: der Heute-Text und
         die Schlagzeile – beide gehören in denselben Kasten. -->
    @for (eintrag of e.texte; track $index) {
      <div class="ki-ergebnis__eintrag">
        <p class="ki-ergebnis__ziel">
          @if (eintrag.uebernommen) {
            <mat-icon>edit_note</mat-icon>
            <span>In die Textbox "{{ eintrag.ziel }}" im Reiter "KI-Texte" übernommen.</span>
          } @else {
            <mat-icon>report_problem</mat-icon>
            <span>Nicht übernommen &ndash; keine passende Textbox im Reiter "KI-Texte".</span>
          }
          <span class="ki-ergebnis__meta">
            aus {{ eintrag.boxen }} {{ eintrag.boxen === 1 ? 'Box' : 'Boxen' }}
            &middot; {{ eintrag.zeitpunkt | date: 'HH:mm:ss' }}
          </span>
        </p>
        <p class="ki-ergebnis__text">{{ eintrag.text }}</p>
      </div>
    }
  </div>
}
